import { Box, Button, ButtonSize, Heading, Icon, IconSize, ModalBody, Radio, TextFieldSize } from '@bechtel/gds';
import { Formik } from 'formik';
import { FC } from 'react';
import { FormSectionHeading, MultiLingualText } from '~/components';
import { TermEnd } from '../types';
import {
  BoxContainerStyled,
  FooterButtonStyled,
  ListSelectionStyled,
  ModalCloseStyled,
  ModalFooterStyled,
  ModalHeaderStyled,
  ModalStyled,
} from './styled';

const initialValues = {
  deleteTermOption: TermEnd.BOTH_FROM_AND_TO,
};

interface DeleteTermModalProps {
  onDeleteTerm: (deleteTermOption: TermEnd) => void;
  onClose: () => void;
}

export const DeleteTermModal: FC<DeleteTermModalProps> = ({ onDeleteTerm, onClose }) => {
  return (
    <>
      <ModalStyled visible>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onDeleteTerm(values.deleteTermOption);
          }}
        >
          {({ values, setFieldValue, handleSubmit }) => {
            return (
              <>
                <ModalHeaderStyled title="">
                  <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-evenly' }}>
                    <Box pl={{ sm: '300' }}>
                      <Heading size="500" weight="500">
                        <MultiLingualText>Delete Terminations</MultiLingualText>
                      </Heading>
                    </Box>
                    <ModalCloseStyled
                      onClick={() => {
                        onClose();
                      }}
                    >
                      <Button
                        size={ButtonSize.SMALL}
                        style={{ background: 'transparent', boxShadow: 'none' }}
                        onClick={() => close()}
                      >
                        <Icon icon="times" iconStyle="regular" size={IconSize.LARGE} />
                      </Button>
                    </ModalCloseStyled>
                  </Box>
                </ModalHeaderStyled>
                {/* @ts-ignore adjust in GDS component to take child as prop  */}
                <ModalBody
                  css={`
                    flex-direction: column;
                  `}
                >
                  <form style={{ width: '100%' }}>
                    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }} p={{ sm: '500' }}>
                      <Box flexDirection={{ sm: 'column' }}>
                        <FormSectionHeading heading="Terminations To Be Deleted" />
                      </Box>
                      <BoxContainerStyled>
                        <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
                          <Box>
                            <ListSelectionStyled
                              onClick={() => setFieldValue('deleteTermOption', TermEnd.BOTH_FROM_AND_TO)}
                            >
                              <Box mr={{ sm: '500' }}>
                                <Radio
                                  size={TextFieldSize.MEDIUM}
                                  checked={values.deleteTermOption === TermEnd.BOTH_FROM_AND_TO}
                                  readOnly={true}
                                />
                              </Box>
                              <MultiLingualText size="300" color="grey.900">
                                Both FROM and TO ends
                              </MultiLingualText>
                            </ListSelectionStyled>
                          </Box>

                          <Box>
                            <ListSelectionStyled onClick={() => setFieldValue('deleteTermOption', TermEnd.FROM_ONLY)}>
                              <Box mr={{ sm: '500' }}>
                                <Radio
                                  size={TextFieldSize.MEDIUM}
                                  checked={values.deleteTermOption === TermEnd.FROM_ONLY}
                                  readOnly={true}
                                />
                              </Box>
                              <MultiLingualText size="300" color="grey.900">
                                FROM ends only
                              </MultiLingualText>
                            </ListSelectionStyled>
                          </Box>

                          <Box>
                            <ListSelectionStyled onClick={() => setFieldValue('deleteTermOption', TermEnd.TO_ONLY)}>
                              <Box mr={{ sm: '500' }}>
                                <Radio
                                  size={TextFieldSize.MEDIUM}
                                  checked={values.deleteTermOption === TermEnd.TO_ONLY}
                                  readOnly={true}
                                />
                              </Box>
                              <MultiLingualText size="300" color="grey.900">
                                TO ends only
                              </MultiLingualText>
                            </ListSelectionStyled>
                          </Box>
                        </Box>
                      </BoxContainerStyled>
                    </Box>
                  </form>
                </ModalBody>
                <ModalFooterStyled>
                  <Box p={{ sm: '500' }}>
                    <FooterButtonStyled onClick={() => handleSubmit()}>
                      <Box px={{ sm: '500' }}>
                        <MultiLingualText>OK</MultiLingualText>
                      </Box>
                    </FooterButtonStyled>
                  </Box>
                </ModalFooterStyled>
              </>
            );
          }}
        </Formik>
      </ModalStyled>
    </>
  );
};
